// Rule applied: Use Hotwire (Turbo and Stimulus) for dynamic, SPA-like interactions
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["rating", "cleanliness", "communication", "value"]

  validateAndSubmit(event) {
    // Prevent form submission if any rating is missing
    const ratings = [
      this.ratingTarget.querySelector('input').value,
      this.cleanlinessTarget.querySelector('input').value,
      this.communicationTarget.querySelector('input').value,
      this.valueTarget.querySelector('input').value
    ]

    if (ratings.some(rating => !rating)) {
      event.preventDefault()
      this.showError("Please provide all ratings before submitting")
      return
    }
  }

  showError(message) {
    const flash = document.createElement('div')
    flash.className = 'mb-4 rounded-md bg-red-50 dark:bg-red-900/30 p-4'
    flash.innerHTML = `
      <div class="flex">
        <div class="flex-shrink-0">
          <i class="ph ph-warning-circle text-red-400 dark:text-red-500"></i>
        </div>
        <div class="ml-3">
          <p class="text-sm font-medium text-red-800 dark:text-red-200">${message}</p>
        </div>
      </div>
    `

    // Insert at the top of the form
    this.element.insertBefore(flash, this.element.firstChild)

    // Remove after 5 seconds
    setTimeout(() => flash.remove(), 5000)
  }
}
